export const ENDPOINT_REGIONAL_ADMINISTRATIONS_FIND_ALL = '/api/regional-administrations/list';
export const ENDPOINT_REGIONAL_ADMINISTRATIONS_FIND_ONE = '/api/regional-administrations/get-one';
export const ENDPOINT_REGIONAL_ADMINISTRATIONS_CREATE_ONE = '/api/regional-administrations/create';
export const ENDPOINT_REGIONAL_ADMINISTRATIONS_DELETE_ONE = '/api/regional-administrations/delete';
export const ENDPOINT_REGIONAL_ADMINISTRATIONS_UPDATE_ONE = '/api/regional-administrations/update';
